export default __webpack_public_path__ + "static/media/service-request.b6b9040b.jpg";